// extracted by mini-css-extract-plugin
export default {"main":"style_main__M+YDS","fullscreen":"style_fullscreen__wSj-E"};